import React from 'react'

import { useForm } from '../../../packages/kiti/components/form/form/FormHandler'
import WidgetPreview from '../../../containers/screens/widgets/WidgetPreview'

const Preview = () => {
  const form = useForm()

  return <WidgetPreview widget={form} />
}

export default Preview
